/* Maison Solière · Guardados (oct 2026)
   Lista en localStorage "maisonFavorites" (array de handles), la misma
   que escribe el botón Guardar de la PDP (maison-product.js). */
(() => {
  const root = document.querySelector("[data-maison-favorites]");
  if (!root) return;

  const STORAGE_KEY = "maisonFavorites";
  const grid = root.querySelector("[data-favorites-grid]");
  const empty = root.querySelector("[data-favorites-empty]");
  const loading = root.querySelector("[data-favorites-loading]");
  const count = root.querySelector("[data-favorites-count]");
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function read() {
    try {
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(list) ? list.filter((h) => typeof h === "string" && h) : [];
    } catch (error) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      /* localStorage no disponible */
    }
  }

  function updateState() {
    const items = grid.querySelectorAll("[data-favorite-item]").length;
    empty.hidden = items > 0;
    grid.hidden = items === 0;
    count.textContent =
      items === 0 ? "" : items === 1 ? "1 fragancia guardada" : `${items} fragancias guardadas`;
  }

  async function fetchCard(handle) {
    const url = `${base}products/${encodeURIComponent(handle)}?view=favorito`;
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error(String(response.status));
    const html = await response.text();
    const template = document.createElement("template");
    template.innerHTML = html.trim();
    const item = template.content.querySelector("[data-favorite-item]");
    if (!item) throw new Error("sin tarjeta");
    return item;
  }

  async function render() {
    const handles = read();
    grid.innerHTML = "";

    if (handles.length === 0) {
      loading.hidden = true;
      updateState();
      return;
    }

    /* Más recientes primero. */
    const ordered = handles.slice().reverse();
    const results = await Promise.allSettled(ordered.map(fetchCard));
    const missing = [];

    results.forEach((result, i) => {
      if (result.status === "fulfilled") {
        grid.appendChild(result.value);
      } else if (/^404$/.test(result.reason && result.reason.message)) {
        missing.push(ordered[i]);
      }
    });

    /* Productos que ya no existen o no están publicados: se limpian. */
    if (missing.length) write(read().filter((h) => !missing.includes(h)));

    loading.hidden = true;
    updateState();
  }

  grid.addEventListener("click", (event) => {
    const button = event.target.closest("[data-favorite-remove]");
    if (!button) return;
    event.preventDefault();
    const item = button.closest("[data-favorite-item]");
    const handle = item && item.dataset.handle;
    write(read().filter((h) => h !== handle));
    item.classList.add("is-removing");
    window.setTimeout(() => {
      item.remove();
      updateState();
    }, 220);
  });

  window.addEventListener("storage", (event) => {
    if (event.key === STORAGE_KEY) render();
  });

  render();
})();
